import { getUserRegional } from '@/utils/locale.js'
import { checkFromType } from '@/utils/checkLoginFromType'
import { getBusinessType } from '@/constant'
import store from '@/store'

/**
 * 根路由入口跳转判断
 * @param {*} to 路由信息
 * @returns 跳转路径
 * query.enter 有值则表示进入新登录界面 login 登录 register ...
 * query.gi_guest 嘉宾id
 * query.event_id 活动id
 * query.alias 活动url前缀
 */
export const redirect = async function (to) {
  const q = { ...to.query }
  const _from = checkFromType(to)


  // 嘉宾enter参数单独处理
  if (_from === 'guest') {
    let { data } = await store.dispatch('CheckUser', {
      user_name: q.gi_address,
    })
   
    store.commit('setCurrentAccount', q.gi_address)
    // 已注册嘉宾跳转至登录
    const toRouter = data === true ? 'register' : 'login'
    return `/${toRouter}/email/detail`
  }

  const _enter = q.enter

  // 绑定个人信息/绑定邮箱信息
  if (_enter === 'bindphone' || _enter === 'bindemail' ) {
    return '/personalInfo'
  }
  // 新登录入口
  // 路由：login or register
  const toRouter = getBusinessType().isMergeLoginAndRegister ? 'register': ['login', 'register'].indexOf(_enter) !== -1 ? _enter : 'login'
  // 步骤：account or detail
  const toStep = getBusinessType().isMergeLoginAndRegister ? 'detail':  ((toRouter === 'register' && _from !== 'platform')) ? 'detail' : 'account'
  // 方式：phone or email
  const { type } = await getUserRegional()
  const toType = _from === 'guest' ? 'email' : type
  const finalPath = getBusinessType().hasCustomLoginPage ?  getBusinessType().unionId: `/${toRouter}/${toType}/${toStep}`
  return finalPath
}